import React from "react";

/**
 * Logo FlowKraft reconstruit en texte d'après public/logo-hz.jpeg.
 *
 * Relevés sur le fichier source (294 x 93 px), en pixels d'encre :
 *  - "FLOWKRAFT" : hauteur de capitale 31px, largeur 279px, graisse lourde,
 *                  lettres quasi jointives (1 à 2px d'écart)
 *  - "AGENCY"    : hauteur de capitale 22px (0.71x), largeur 120px, graisse
 *                  légère, centré sur le mot-symbole
 *  - écart ligne 1 / ligne 2 : 17px, soit 0.55x la hauteur de capitale
 *  - "FLOW" blanc, "KRAFT" violet (#896D9C relevé ≈ flowkraft-primary #8B7B9E)
 *
 * Le mot-symbole est rendu en Outfit Bold (700), soit un cran sous la graisse
 * du fichier source : plus lisible en petit et moins massif dans la barre de
 * navigation. Outfit étant plus étroit que la fonte d'origine, on conserve
 * l'interlettrage serré du logo plutôt que d'écarter les lettres pour rattraper
 * la largeur, la texture jointive étant le trait le plus reconnaissable.
 *
 * `size` pilote la taille du mot-symbole ; "AGENCY" en découle (0.72x).
 */
const Logo = ({ size = "md", className = "" }) => {
  // Tailles en valeurs arbitraires : les utilitaires `text-*` de Tailwind
  // embarquent une line-height qui écraserait le `leading-none` du lockup.
  const sizes = {
    sm: { word: "text-[1.25rem] md:text-[1.5rem]", tag: "text-[0.9rem] md:text-[1.08rem]" },
    md: { word: "text-[1.5rem] md:text-[1.875rem]", tag: "text-[1.08rem] md:text-[1.35rem]" },
    lg: { word: "text-[1.875rem] md:text-[2.25rem]", tag: "text-[1.35rem] md:text-[1.62rem]" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <span className={`inline-flex flex-col items-center leading-none select-none ${className}`}>
      <span className={`font-sans font-bold uppercase tracking-normal leading-none text-white ${s.word}`}>
        Flow
        <span className="text-flowkraft-primary transition-colors duration-300 group-hover:text-flowkraft-secondary">
          Kraft
        </span>
      </span>
      <span className={`font-sans font-medium uppercase tracking-normal text-white mt-[0.215em] ${s.tag}`}>
        Agency
      </span>
    </span>
  );
};

export default Logo;
